import React from "react";
import { joinClasses } from "./resultsPrimitives/shared.js";

export default function PageSurfaceHeader({
  actions = null,
  actionsClassName = "",
  className = "",
  copyClassName = "",
  description = "",
  descriptionClassName = "",
  descriptionProps = {},
  eyebrow = "",
  eyebrowClassName = "",
  eyebrowProps = {},
  indicators = null,
  indicatorsClassName = "",
  indicatorsProps = {},
  lead = null,
  leadClassName = "",
  title = "",
  titleAs: TitleTag = "h2",
  titleClassName = "",
  titlePrefix = null,
  titleProps = {},
  titleRowClassName = "",
  titleSuffix = null,
}) {
  const hasCopy = Boolean(lead || eyebrow || title || description);
  const hasIndicators = Boolean(indicators);
  const resolvedCopyClassName = copyClassName || "max-w-3xl";

  if (!hasCopy && !actions) {
    return null;
  }

  return (
    <div className={joinClasses(["flex flex-wrap items-start justify-between gap-4", className])}>
      {hasCopy ? (
        <div className={joinClasses(["min-w-0", resolvedCopyClassName])}>
          {lead ? (
            <div className={joinClasses(["flex flex-wrap items-center gap-2.5", leadClassName])}>
              {lead}
            </div>
          ) : null}

          {eyebrow ? (
            <p
              className={joinClasses([
                "text-[11px] font-semibold uppercase leading-[1.35] tracking-[0.22em] text-slate-500",
                eyebrowClassName,
              ])}
              {...eyebrowProps}
            >
              {eyebrow}
            </p>
          ) : null}

          {title ? (
            <div className={joinClasses(["flex flex-wrap items-center gap-2.5", titleRowClassName])}>
              {titlePrefix ? <div className="shrink-0">{titlePrefix}</div> : null}

              <TitleTag
                className={joinClasses([
                  "font-display leading-[1.04] tracking-[-0.04em] text-slate-950",
                  titleClassName,
                ])}
                {...titleProps}
              >
                {title}
              </TitleTag>

              {titleSuffix ? <div className="shrink-0">{titleSuffix}</div> : null}

              {hasIndicators ? (
                <div
                  className={joinClasses([
                    "flex flex-wrap items-center gap-2",
                    indicatorsClassName,
                  ])}
                  {...indicatorsProps}
                >
                  {indicators}
                </div>
              ) : null}
            </div>
          ) : null}

          {description ? (
            <p
              className={joinClasses([
                "text-[13px] leading-6 text-slate-600",
                descriptionClassName,
              ])}
              {...descriptionProps}
            >
              {description}
            </p>
          ) : null}

        </div>
      ) : null}

      {actions ? (
        <div className={joinClasses(["flex flex-wrap gap-2", actionsClassName])}>
          {actions}
        </div>
      ) : null}
    </div>
  );
}